class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);

    // Position search/drawer chrome below announcement + header at open time.
    // --header-height alone is only the sticky header section and misses the
    // announcement bar while the page is still scrolled to the top.
    //
    // IMPORTANT: measure the header BEFORE locking body scroll. Adding
    // `overflow-hidden` to the body disables the header's `position: sticky`,
    // which makes getBoundingClientRect() report a stale, off-screen value and
    // sends the search overlay flying off screen when the page is scrolled.
    const header = document.querySelector('.section-header');
    let headerIsStuckToTop = false;
    if (header) {
      const headerRect = header.getBoundingClientRect();
      document.documentElement.style.setProperty('--header-bottom-position', `${Math.round(headerRect.bottom)}px`);
      // The header is currently "stuck" to the top of the viewport (sticky
      // header while the page is scrolled) when its top edge is at/above 0 and
      // the page is actually scrolled. In that state we must pin it explicitly
      // once scroll is locked (see below).
      headerIsStuckToTop = window.scrollY > 0 && headerRect.top <= 0.5;
    }

    document.body.classList.add('overflow-hidden');

    // Once the body is scroll-locked (overflow:hidden) the header's
    // position:sticky stops working, so it would collapse to the top of the
    // document behind the overlay. When the header was stuck to the top due to
    // scrolling, pin it explicitly (via CSS) so it stays visible above the
    // search overlay and keeps matching the captured --header-bottom-position.
    if (this.classList.contains('header__search')) {
      document.body.classList.add('search-modal-open');
      if (headerIsStuckToTop) {
        document.body.classList.add('search-modal-sticky');
      }
    }

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('search-modal-open');
    document.body.classList.remove('search-modal-sticky');
  }
}

customElements.define('details-modal', DetailsModal);
